import request from "@/service";

/* 查询问卷分页列表 */
export function getQuestionPaperList(params) {
  return request({
    url: `/interact/questionnaire/page`,
    method: "get",
    params
  });
}

/* 问卷新增 */
export function saveQuestionnaire(params) {
  return request({
    url: `/interact/questionnaire/save`,
    method: "post",
    data: params
  });
}

/* 问卷预览详情 */
export function previewQuestionnaire(params) {
  return request({
    url: `/interact/questionnaire/preview/${params}`,
    method: "get"
  });
}

/* 问卷详情 */
export function getQuestionnaireInfo(uuid) {
  return request({
    url: `/interact/questionnaire/info/${uuid}`,
    method: "get"
  });
}

/* 问卷修改 */
export function updateQuestionnaire(params) {
  return request({
    url: `/interact/questionnaire/update`,
    method: "put",
    data: params
  });
}

/* 问卷删除 */
export function deleteQuestion(params) {
  return request({
    url: `/interact/questionnaire/delete`,
    method: "delete",
    data: params
  });
}

/* 复制问卷 */
export function copyQueationPaper(params) {
  return request({
    url: `/interact/questionnaire/copy/${params}`,
    method: "get"
  });
}

/* 发布/取消发布 */
export function publishQueationPaper(uuid, status) {
  return request({
    url: `/interact/questionnaire/publish/${uuid}/${status}`,
    method: "get"
  });
}

/* 已发布问卷名称列表 */
export function getPublishedInvesList(params) {
  return request({
    url: `/interact/questionnaire/list`,
    method: "get",
    params
  });
}
